<template>
  <div>
    <Modal v-model="showModal" title="选择Jenkins - Job" width="1000" @on-cancel="initSelected">
      <span style="margin-right:5px;">选择Jenkins</span>
      <Select v-model="selectedJenkins" filterable @on-change="getViewsList()" style="width:74%;">
        <Option v-for="item in jenkinsList" :key="item.id" :value="item.id">{{ item.name }}</Option>
      </Select>
      <Divider />
      <div>
        <span>已选Job(<b>{{ selectRow.length }}</b>)：<a v-on:click="emptySelect" v-if="selectRow.length">清空 </a> </span>
        <Tag color="primary" closable v-for="(item, index) in selectRow" :key="'job_' + index" @on-close="cancelSelected('remove', item.name)">{{ item.name }}</Tag>
      </div>
      <Divider />
      <Tabs :value="jobSearchForm.view_name" @on-click="viewsTabClick">
        <TabPane :label="item.name" :name="item.name" v-for="(item, index) in viewsList" :key="'view_' + index"></TabPane>
      </Tabs>
      <Alert v-if="jobsListError" type="warning" show-icon>获取数据失败</Alert>
      <div v-else>
        <Form :model="jobSearchForm" ref="jobSearchForm" inline :label-width="40" @submit.native.prevent>
          <FormItem label="筛选">
            <Input v-model="jobSearchForm.job_name" style="min-width: 200px" placeholder="Job名称" @keyup.enter.native="getJobsList()" />
          </FormItem>
          <FormItem :label-width="0" class="mob-align-right">
            <Button type="primary" @click="getfilterJobs()">搜索</Button>
          </FormItem>
        </Form>
        <div v-if="jobSearchForm.folder_name">
          <Breadcrumb>
            <BreadcrumbItem><a v-on:click="folderClick(-1)">Home</a></BreadcrumbItem>
            <BreadcrumbItem v-for="(item, idx) in jobSearchForm.folder_name.split('/')" :key="idx"><a v-on:click="folderClick(idx)">{{ item }}</a></BreadcrumbItem>
          </Breadcrumb>
          <Divider/>
        </div>
        <Table
          stripe
          border
          highlight-row
          :loading="jobsTableLoading"
          ref="jobsTable"
          :data="jobs.data"
          :columns="jobs.columns"></Table>
        <div style="margin: 10px 0; overflow: hidden;">
          <div style="float: left;">
            当前显示 {{ jobs.data.length }} 条记录，总共 {{ jobs.count }} 条记录
          </div>
          <div style="float: right;">
            <page
              :total="jobs.count"
              :current="jobs.page"
              :page-size="jobs.size"
              @on-change="getJobsList"></page>
          </div>
        </div>
      </div>
      <div slot="footer">
        <Button type="primary" style="margin-right: 8px" @click="selectOk">确定</Button>
        <Button @click="showModal = false; initSelected()">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { getJenkinsAllList, getJenkinsJobs, getJenkinsViews } from '@/api/tools/jenkins'
export default {
  name: 'select-jenkins-jobs',
  props: {
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showModal: false,
      selectRow: [],
      selectedJenkins: '',
      jenkinsList: [],
      jenkinsListError: false,
      viewsList: [],
      viewsListError: [],
      jobs: {
        data: [],
        columns: [
          {
            title: '选中',
            align: 'center',
            width: 70,
            key: 'checkBox',
            render: (h, params) => {
              let isCheck = false
              if (this.selectRow.map(item => item.name).indexOf(params.row.name) > -1) {
                isCheck = true
              }
              return h('div', [
                h('Checkbox', {
                  props: {
                    value: isCheck,
                    disabled: params.row._class === 'com.cloudbees.hudson.plugins.folder.Folder' ? true : false
                  },
                  on: {
                    'on-change': (e) => {
                      this.jobs.data[params.index].checkBox = e
                      if (e) {
                        if (!this.multiple) {
                          this.emptySelect()
                        }
                        if (this.selectRow.map(item => item.name).indexOf(params.row.name) < 0) {
                          console.log(this.selectRow)
                          if (this.jobSearchForm.folder_name) {
                            // jobName = `${this.jobSearchForm.folder_name}/${jobName}`
                            this.selectRow.push({ 'id': this.selectedJenkins, 'name': this.jobSearchForm.folder_name + "/" + params.row.name })
                          } else{
                            this.selectRow.push({ 'id': this.selectedJenkins, 'name': params.row.name })
                          }
                          
                        }
                      } else {
                        this.cancelSelected(null, params.row.name)
                      }
                    }
                  }
                })
              ])
            }
          },
          {
            title: 'Job名称',
            key: 'name',
            align: 'center',
            tooltip: true,
            minWidth: 200,
            render: (h, params) => {
              let aL = []
              if (params.row._class === 'com.cloudbees.hudson.plugins.folder.Folder') {
                aL.push(h('Icon', {
                  props: {
                    type: 'md-folder',
                    size: 20
                  },
                  style: { color: '#2db7f5', marginRight: '5px' }
                }))
                aL.push(h('span', {
                  on: {
                    click: () => {
                      let folders = []
                      if (this.jobSearchForm.folder_name) {
                        folders = this.jobSearchForm.folder_name.split('/')
                      }
                      folders.push(params.row.name)
                      this.jobSearchForm.folder_name = folders.join('/')
                      this.getJobsList()
                    }
                  }
                }, params.row.name))
              } else {
                aL.push(h('span', {
                  on: {
                    click: () => {
                      let jobName = params.row.name
                      if (this.jobSearchForm.folder_name) {
                        jobName = `${this.jobSearchForm.folder_name}/${jobName}`
                      }
                      this.$router.push({ name: 'jenkins_job_detail', params: { id: this.$route.params.id, job_name: jobName }, query: { lastPage: this.jobs.page } })
                    }
                  }
                }, params.row.name))
              }
              return h('a', aL)
            }
          },
          {
            title: '描述',
            key: 'description',
            align: 'left',
            tooltip: true,
            minWidth: 150
          },
          {
            title: '上次构建状态',
            key: 'color',
            align: 'center',
            tooltip: true,
            minWidth: 110,
            render: (h, params) => {
              if (params.row.color) {
                return h('Tag', {
                  props: {
                    color: params.row.color === 'blue' ? 'green'
                      : params.row.color === 'disabled' ? 'default'
                        : params.row.color === 'red' ? 'red'
                          : params.row.color === 'aborted' ? 'gold'
                            : params.row.color === 'notbuilt' ? 'blue'
                              : 'blue'
                  }
                }, params.row.color === 'blue' ? '成功'
                  : params.row.color === 'disabled' ? '禁用'
                    : params.row.color === 'red' ? '失败'
                      : params.row.color === 'aborted' ? '已终止'
                        : params.row.color === 'notbuilt' ? '未构建'
                          : params.row.color)
              } else {
                return ''
              }
            }
          }
        ],
        count: 0,
        page: 1,
        size: 5
      },
      jobsListError: false,
      jobsTableLoading: false,
      jobSearchForm: {
        folder_name: '',
        view_name: '',
        job_name: ''
      },
      callbackParams: null
    }
  },
  methods: {
    // 打开选择对话框
    openModal (selected, jenkinsId, callbackParams) {
      if (selected) {
        this.selectRow = this.multiple ? selected : [selected]
      }
      this.getJenkinsList()
      if (jenkinsId) {
        this.selectedJenkins = jenkinsId
        this.getViewsList()
      }
      this.callbackParams = callbackParams
      this.showModal = true
    },
    // 获取Jenkins列表
    getJenkinsList () {
      this.jenkinsListError = false
      getJenkinsAllList().then(res => {
        this.jenkinsList = res.data
      }).catch(res => {
        console.log(res.response)
        this.jenkinsListError = true
      })
    },
    folderClick (depth) {
      if (depth < 0) {
        this.jobSearchForm.folder_name = ''
      } else {
        this.jobSearchForm.folder_name = this.jobSearchForm.folder_name.split('/').slice(0, depth + 1).join('/')
      }
      this.getJobsList()
    },
    // 获取View列表
    getViewsList () {
      if (this.selectedJenkins) {
        this.viewsListError = false
        getJenkinsViews(this.selectedJenkins).then(res => {
          this.viewsList = res.data
          this.jobSearchForm.view_name = 'all'
          this.getJobsList()
        }).catch(res => {
          console.log(res.response)
          this.viewsListError = true
        })
      }
    },
    getfilterJobs () {
      this.jobSearchForm.folder_name = ''
      this.getJobsList()
    },

    // 获取Job列表
    getJobsList (value = 1) {
      if (this.selectedJenkins) {
        this.jobs.page = value
        this.jobsListError = false
        this.jobsTableLoading = true
        this.jobSearchForm['size'] = this.jobs.size
        this.jobSearchForm['page'] = this.jobs.page
        getJenkinsJobs(this.selectedJenkins, this.jobSearchForm).then(res => {
          let result = res.data
          this.jobs.data = result.results
          this.jobs.count = result.count
          this.jobsTableLoading = false
        }).catch(res => {
          console.log(res.response)
          this.jobsTableLoading = false
          this.jobsListError = true
        })
      } else {
        this.$Message['error']({
          background: true,
          content: '请先选择Jenkins',
          duration: 5
        })
      }
    },
    // 切换View标签
    viewsTabClick (name) {
      this.jobSearchForm.view_name = name
      this.jobSearchForm.job_name = ''
      this.getJobsList()
    },
    // 取消选中
    cancelSelected (event, name) {
      console.log(name)
      if (event) {
        for (let i in this.jobs.data) {
          if (this.jobs.data[i].name === name) {
            this.jobs.data[i].checkBox = false
            break
          }
        }
      }
      this.selectRow = this.selectRow.filter(item => !(item.name.indexOf(name) > -1))
    },
    // 清空选中
    emptySelect () {
      for (let i in this.jobs.data) {
        this.jobs.data[i].checkBox = false
      }
      this.selectRow = []
    },
    initSelected () {
      this.selectedJenkins = ''
      this.selectRow = []
      this.callbackParams = null
      this.viewsList = []
      this.jobs.data = []
    },
    // 选择完成
    selectOk () {
      if (this.multiple) {
        this.$emit('selectComplete', this.selectedJenkins, this.selectRow, this.callbackParams)
      } else {
        this.$emit('selectComplete', this.selectedJenkins, this.selectRow.length ? this.selectRow[0] : '',
          this.callbackParams)
      }
      this.showModal = false
      this.initSelected()
    }
  }
}
</script>

<style scoped>

</style>
